import { GetterTree } from "vuex";
import { IProgramContentState } from ".";
import { IRootState } from "@/store/types";
import { IAsset } from "@/models/asset";

export const getters: GetterTree<IProgramContentState, IRootState> = {
    programContentsList(state): IAsset[] | null {
        return state.programContentsList;
    },
    selectedProgramContent(state): IAsset | null {
        return state.selectedProgramContent;
    },
    error(state): any {
        return state.error;
    },
};
